'use client';

import { PortableTextSimple } from '@/components/portable-text/portable-text-simple';
import type { PortableTextSimpleQueryResult } from '@/components/portable-text/portable-text-simple-types';
import { buttonVariants } from '@/components/ui/button';
import { ProductListingSecondaryDescription } from '@veranda/shared/components/pages/product-listing';
import { cn } from '@veranda/shared/lib';
import type { PortableTextBlock } from 'next-sanity';

export function SecondaryDescription({
  content,
  containerClassName,
}: {
  content: PortableTextBlock[] | null;
  containerClassName?: string;
}) {
  return (
    <ProductListingSecondaryDescription
      content={content}
      containerClassName={containerClassName}
      buttonClassName={cn(buttonVariants())}
    >
      {(content) => (
        <PortableTextSimple
          content={
            content as NonNullable<PortableTextSimpleQueryResult>['content']
          }
        />
      )}
    </ProductListingSecondaryDescription>
  );
}
